export const DatabasePrefix = 'AppDatabase-'
